import { AUTHENTICATION_FRENCH_LOCALE } from "~ui/@application/locales/modules/authentication/authentication.fr.ts";
import { COMMON_FRENCH_LOCALE } from "~ui/@application/locales/modules/common/common.fr.ts";
import { COMPONENTS_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/components.fr.ts";

export const FRENCH_LOCALE = {
  common: COMMON_FRENCH_LOCALE,
  components: COMPONENTS_FRENCH_LOCALE,
  authentication: AUTHENTICATION_FRENCH_LOCALE,
};

export default FRENCH_LOCALE;
